export const ROOT_BONSAI_NODE = '_bonsaiTreeRoot';
export const SEARCH_ROOT_BONSAI_NODE = '_bonsaiSearchTreeRoot';

// TODO-AI: Consolidate the above into the below
export enum Bonsai {
  RootNode = '_bonsaiTreeRoot',
}
